import { Parameter } from './../../models/class/parameter/parameter';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParametersOffer } from 'app/shared/models/class/parameter/parameter';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ParametersService {

  private baseUrl: string = environment.apiUrl + '/Parameter/Parameters';
  numberOfParametersRequired = 4;

  parameters: Parameter[];

  parametersRequired: ParametersOffer[] = [
    {
      label: 'Date de naissance',
      type: 'date',
      values: [],
      isRequired: false,
    },
    {
      label: 'Message vers le club',
      type: 'texte',
      values: [],
      isRequired: false,
    },
    {
      label: 'Ville de résidence',
      type: 'texte',
      values: [],
      isRequired: false,
    },
    {
      label: 'Numéro de licence',
      type: 'texte',
      values: [],
      isRequired: false,
    },


  ];


  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getParameters(): Observable<Parameter[]> {
    return this.http.get<Parameter[]>(this.baseUrl)
      .pipe(
        map(parameters => {
          this.parameters = parameters.map(p => Parameter.fromObject(p));
          return [...this.parameters];
        })
      );
  }

  getParametersActive(): Observable<Parameter[]> {
    return this.http.get<Parameter[]>(`${environment.apiUrl}/Parameter/ActiveParameters`)
      .pipe(
        map(parameters => {
          this.parameters = parameters.map(p => Parameter.fromObject(p));
          return [...this.parameters];
        })
      );
  }

  /* -------------------------------------------------------------------------- */
  /*                                     POST                                    */
  /* -------------------------------------------------------------------------- */

  addParameter(parameter: Parameter) {
    return this.http.post(`${this.baseUrl}`, parameter);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateParameter(parameter: Parameter) {
    return this.http.put(`${this.baseUrl}`, parameter);
  }

  activateDesactivateParameter(parameter: Parameter, value: boolean) {
    return this.http.put(`${this.baseUrl}/ActivateParameter/${parameter.parameterKey}/${value}`, null);
  }

}
